<template>
  <div class="page">
    <el-dialog
			title="编辑"
			:visible.sync="downDataDialog"
			:close-on-click-modal="false"
			width="640px"
      id="shopChildDialog">
			<el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
          <!-- 基本字段 -->
        <div class="seaerch-wrapper">
          <el-form :model="modalInfo.basicform" ref="ruleForm" label-width="130px">
            <span v-for="(value, key) in modalInfo.props" :key="key" v-if="value.prop=='wangwang'?(isExitWangwang(modalInfo.basicform.platformCode)?true:false):true">
              <el-form-item style="width: 425px;"
                :label="value.label" :prop="value.prop == 'platformname'?'platformCode':value.prop"
                v-if="value.fieldClassify == 'basic'&&value.isChecked" :rules="value.fieldRequired == '1'?{
                required: true, message:value.label+'不能为空',trigger: ['blur', 'change']}:null">
                  <!-- 平台 -->
                  <el-select style="width: 425px;" v-if="value.prop == 'platformname'" v-model="modalInfo.basicform.platformCode" placeholder="请选择" size="small" clearable>
                    <el-option
                      v-for="item in modalInfo.plateform"
                      :key="item.dictCode"
                      :value="item.dictCode"
                      :label="item.dictName"
                    ></el-option>
                  </el-select>
                  <!-- 经营品类 -->
                    <el-select :disabled="true" style="width: 425px;" v-else-if="value.prop == 'productclassifyid'" value-key="id" v-model="modalInfo.basicform.productclassifyid" multiple  placeholder="请选择" size="small" clearable >
                      <el-option
                        v-for="item in modalInfo.ProductClassify"
                        :key="item.id"
                        :value="item.id"
                        :label="item.productClassifyName"
                      ></el-option>
                  </el-select>
                  <!--开店经销商-->
                  <span v-else-if="value.prop == 'dealername'">
                    <el-select style="width: 425px;" :disabled="true" v-model="modalInfo.basicform[value.prop]" @change="getDealername" filterable placeholder="请选择" size="small" clearable ></el-select>
                  </span>
                  <!-- 供货经销商 -->
                <el-select style="width: 425px;" v-else-if="value.prop == 'supplydealerid'" value-key="id" v-model="modalInfo.basicform.supplydealerid" multiple  placeholder="请选择" size="small" clearable >
                  <el-option
                    v-for="item in modalInfo.dealernameList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.dealername"
                  ></el-option>
                </el-select>
                  <!-- 直属上级 -->
                  <el-select style="width: 425px;" :disabled="true" v-else-if="value.prop == 'brandtakepeople'" v-model="modalInfo.brandtakepeoplename"></el-select>

                  <el-input style="width: 425px;" v-else v-model="modalInfo.basicform[value.prop]"  size="small" clearable  onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
              </el-form-item>
            </span>
          </el-form>
          <!-- 新增字段 -->
          <el-form :model="modalInfo.addform" ref="ruleForm2" class="add-form">
            <el-form-item v-for="(value, key) in modalInfo.props" :key="key"
              :label="value.label" :prop="value.prop" :label-width="formLabelWidth"
              v-if="value.fieldClassify == 'add'&&value.isChecked" :rules="value.fieldRequired == '1'?{
              required: true, message:value.label+'不能为空',trigger: ['blur', 'change']}:null"
              >
                <el-input v-model="modalInfo.addform[value.prop]" size="small" clearable style="width: 425px;">
                </el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" class="confirm" @click="confirmClick()">确 定</el-button>
        <el-button size="small" class="cancel" @click="downDataDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
    import {fetchGet} from "@/libs/reqCommon";
    import { mapActions, mapState,mapGetters } from 'vuex';
    export default {
        name: 'dpEditor',
        data() {
          return {
            formLabelWidth: "130px",
            valueId:"",
            props:{   // 配置项（必选）
                value:'value',
                label: 'title',
                children: 'children'
            },
            screenQuery: [],
            modalInfo:[],
            basicField:[],//基础字段
            addField:[],
            downDataDialog: false,
          };
        },
        computed: {
            ...mapState({
                dealernameList: state => state.commonList.dealernameList
            }),
            ...mapGetters(["plateList"])
        },
        // created(){
        //   this.reqPlateList()
        //   this.reqDealernameList(null)
        //   this.initTableColum()
        // },
        methods: {
          startEditor(data) {
            this.dataShopId = data.shopId
            this.reqPlateList()
            this.reqDealernameList(null)
            this.initTableColum()
            this.downDataDialog = true
          },
            ...mapActions(["reqDealernameList","reqPlateList"]),
            initTableColum(){
                let query = { module:"SHOP"}
                fetchGet("/hcm/hcmCustomModel/getBybmcidAndModule",query).then(res =>{
                    this.gridColumns = [];this.basicField=[];this.addField=[];
                    if(res.status == "10000"){
                        this.forColum(res.data.add.data.concat(res.data.basic.data))
                    }
                });
                this.handleEdit(this.dataShopId)
            },
            forColum(titles){
                //初始化form自定义内容
                for (var i=0;i<titles.length;i++) {
                    let field = {
                        id:titles[i].id,
                        label:titles[i].fieldname,
                        prop:titles[i].fieldvalue?titles[i].fieldvalue:'',
                        isChecked:titles[i].isChecked?true:false,
                        fieldRequired:titles[i].fieldRequired,
                        fieldClassify:titles[i].fieldClassify,
                        width:titles[i].fieldvalue == 'shopName'?260:titles[i].fieldname.length>3?titles[i].fieldname.length*40:"auto",
                    }
                    if(titles[i].isChecked)
                        this.gridColumns.push(field)
                    if(titles[i].fieldClassify == "basic")
                        this.basicField.push(field)
                    if(titles[i].fieldClassify == "add")
                        this.addField.push(field)
                }
            },
            // 编辑事件
            handleEdit(shopId){
                let query = {
                    shopId:shopId
                }
                fetchGet("/hcm/hcmShop/getById",query).then(res =>{
                    if(res.status == "10000"&&res.data){
                        // 经营品类处理
                        let productclassifyid = res.data.productclassifyid?res.data.productclassifyid.split(","):[];
                        for(let i=0;i<productclassifyid.length;i++){
                            productclassifyid[i] = Number(productclassifyid[i])
                        }
                        // 供货经销商处理
                        let supplydealerid = res.data.supplydealerid?res.data.supplydealerid.split(","):[];
                        for(let i=0;i<supplydealerid.length;i++){
                            supplydealerid[i] = Number(supplydealerid[i])
                        }
                        this.isClicked = "edit";
                        this.linkpath = "编辑";
                        this.modalInfo = {
                            flag:"edit",
                            plateform:this.plateList,
                            brandtakepeoplename:res.data.brandtakepeoplename,
                            bydepartId:this.bydepartId,
                            ProductClassify:this.ProductClassify,//经营品类
                            dealernameList:this.dealernameList,//经销商名称下拉
                            props:this.basicField.concat(this.addField),
                            basicform:{...res.data,productclassifyid:res.data.productClassifyName,supplydealerid:supplydealerid,brandtakepeople:res.data.brandtakepeoplename},
                            addform:res.data,
                            addField:this.addField
                        }
                        console.log(this.modalInfo.plateform)
                        this.valueId=this.modalInfo.basicform.brandtakepeople?this.modalInfo.basicform.brandtakepeople:null
                    }else{
                        this.$message.info("接口数据为空，编辑回显数据是掉的接口！");
                    }
                });
            },
            // 判断平台下的旺旺是否展示
            isExitWangwang(plateform){
                let exitPlatform = ["TB","TM",'1688','SMT','ALST','XY']
                for (let item of exitPlatform) if (item == plateform) return true;
                return false;
            },
            // 下拉树取值
            getValue(value){
                this.valueId = value
                this.modalInfo.basicform.brandtakepeople = value
            },
            change(val) {
                this.screenQuery.push(val);
                this.modalInfo.basicform.screenshots = JSON.stringify(
                    String(this.screenQuery)
                );
            },
            // 获取经销商名称和dealerid
            getDealername(val){
                let obj = {};
                obj = this.modalInfo.dealernameList.find((item)=>{
                    return item.id === val;
                });
                this.modalInfo.basicform.dealerid = val;
                this.modalInfo.basicform.dealername = obj.dealername;
            },
            addProp(obj,keys){
                let addField = {}
                for(let i=0;i<keys.length;i++){
                    if(obj[keys[i]]){
                        addField[keys[i]] = obj[keys[i]]
                    }
                }
                return addField
            },
            confirmClick() {
                let addFields = [];
                let addForm = {};
                if(this.modalInfo.addField){
                    for(let item of this.modalInfo.addField){
                        addFields.push(item.prop)
                    }
                    addForm = this.addProp(this.modalInfo.addform,addFields);//新增字段属性
                }
                let query = {
                    ...this.modalInfo.basicform,
                    system:"BRM",
                    addField:JSON.stringify(addForm),
                    productclassifyid:String(this.modalInfo.basicform.productclassifyid),
                    productClassifyName:this.modalInfo.basicform.productClassifyName?String(this.modalInfo.basicform.productClassifyName):"",
                    supplydealerid:String(this.modalInfo.basicform.supplydealerid)
                }
                let _this = this;
                _this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                      this.$refs.ruleForm2.validate((valid2) => {
                          if(valid2) _this.reqNewAdd(query);
                          console.log('调用父组件')
                          this.$parent.fatherFun();
                          this.downDataDialog = false
                          return false;
                      })
                    } else {
                        return false;
                    }
                });
            },
            // 新增/编辑请求
            reqNewAdd(query) {
                fetch({
                    url: "/hcm/hcmShop/saveHcmShopByBmc",
                    method: "post",
                    data: query,
                    noFormat: true,
                    responseType: "text"
                })
                    .then(result => {
                        let res = JSON.parse(result);
                        if (res.status == "10000") {
                            this.$message({
                                message: "操作成功！",
                                type: res.message
                            });
                            this.modalInfo.isShow = false;
                            this.$emit("reqTableData");
                        } else {
                            this.$message.error(res.message ? res.message : "操作失败！");
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            // 取消
            returnClick(){
                this.modalInfo.isShow = false;
                this.$emit("getIsshow",this.modalInfo.isShow)
            },
        }
    };
</script>
<style lang="scss">
#shopChildDialog {
  .el-dialog__body {
      padding: 0px !important;
  }
}
    .form-span{
        display: inline-flex;
        width: 100%;
        align-items: center;
        .addBtn{
            position: absolute;
            top: 5px;
            right: -100px;
        }
    }
</style>
